
import {
  AUDIENCES_LIST_REQUESTING,
  AUDIENCES_LIST_REQUEST_ERROR,
  AUDIENCES_LIST_RECEIVED,
  AUDIENCES_GET_REQUESTING,
  AUDIENCES_GET_REQUEST_ERROR,
  AUDIENCES_GET_RECEIVED
} from 'actions'

export default function (state = {}, { type, payload }) {
  switch (type) {
    case AUDIENCES_LIST_REQUESTING:
      return {
        ...state,
        [payload.workspaceSlug]: {
          isRequesting: true,
          didRequest: false,
          didRequestFail: false,
          data: []
        }
      }
    case AUDIENCES_LIST_REQUEST_ERROR:
      return {
        ...state,
        [payload.workspaceSlug]: {
          isRequesting: false,
          didRequest: true,
          didRequestFail: true,
          error: payload.error
        }
      }
    case AUDIENCES_LIST_RECEIVED:
      return {
        ...state,
        [payload.workspaceSlug]: {
          isRequesting: false,
          didRequest: true,
          didRequestFail: false,
          data: payload.data
        }
      }
    case AUDIENCES_GET_REQUESTING:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          [payload.audienceId]: {
            isRequesting: true,
            didRequest: false,
            didRequestFail: false,
            data: null
          }
        }
      }
    case AUDIENCES_GET_REQUEST_ERROR:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          [payload.audienceId]: {
            isRequesting: false,
            didRequest: true,
            didRequestFail: true,
            error: payload.error
          }
        }
      }
    case AUDIENCES_GET_RECEIVED:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          [payload.audienceId]: {
            isRequesting: false,
            didRequest: true,
            didRequestFail: false,
            data: payload.data
          }
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/audiences.js